const caseStudies = [
    {
        id: 1,
        category: 'Design',
        title: 'Experience for Agency',
        description: 'Agencio discovering the source behind the ubiquitous filler',
        image: 'assets/images/cases/01.jpg',
    },
    {
        id: 2,
        category: 'UX/UI Design',
        title: 'Crafted with Love',
        description: 'Agencio discovering the source behind the ubiquitous filler',
        image: 'assets/images/cases/02.jpg',
    },
    {
        id: 3,
        category: 'Branding',
        title: 'Colibri Identity',
        description: 'Agencio discovering the source behind the ubiquitous filler',
        image: 'assets/images/cases/03.jpg',
    },
    {
        id: 5,
        category: 'Design',
        title: 'Experience for Agency',
        description: 'Agencio discovering the source behind the ubiquitous filler',
        image: 'assets/images/cases/05.jpg',
    },
    {
        id: 6,
        category: 'UX/UI Design',
        title: 'Crafted with Love',
        description: 'Agencio discovering the source behind the ubiquitous filler',
        image: 'assets/images/cases/06.jpg',
    },
    {
        id: 7,
        category: 'Branding',
        title: 'Colibri Identity',
        description: 'Agencio discovering the source behind the ubiquitous filler',
        image: 'assets/images/cases/07.jpg',
    },
    {
        id: 8,
        category: 'Design',
        title: 'Experience for Agency',
        description: 'Agencio discovering the source behind the ubiquitous filler',
        image: 'assets/images/cases/08.jpg',
    },
];
export default caseStudies;